module.exports = __webpack_public_path__ + "static/media/final-upload-template-may-2018.525711ea.xlsm";


//////////////////
// WEBPACK FOOTER
// ./src/docs/final-upload-template-may-2018.xlsm
// module id = 467
// module chunks = 0